import { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { CloseIcon, colors } from '../../styles';
import { ErrorMessage, Media } from './styles';

import styled from 'styled-components';
import { getIsFetching, setIsFetching } from '../../../store/user';
import { useEmailTag } from '../../../tag-manager/email';

// Home preloads this photo and opens the popup only when it is ready.
export const EMAIL_MODAL_PHOTO = '/imgEmail.webp';

export const ContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  background-color: #233e1f;
  border-radius: 20px;
  overflow: hidden;
`;

const Wrapper = styled.div`
  position: relative;
  display: grid;
  grid-template-columns: 55% 45%;

  @media (max-width: 600px) {
    display: flex;
    flex-direction: column;
  }
`;

const Title = styled.p`
  font-size: 38px;
  color: white;
  text-align: center;
  font-weight: 400;

  @media (max-width: 768px) {
    font-size: 24px;
  }
`;

export const SubTitle = styled.div`
  font-size: 14px;
  line-height: 1.5;
  font-weight: 400;
  margin-top: 4px;
  text-align: center;
  color: white;
`;

const Content2 = styled.div`
  display: flex;
`;

const Subcontent = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 2rem;
  padding-block: 6rem;
  padding-inline: 2rem;

  @media (max-width: 600px) {
    padding-block: 2rem;
  }

  div {
    display: flex;
    flex-direction: column;
    gap: 1rem;

    @media (max-width: 600px) {
      padding-inline: 1.2rem;
    }
  }
`;
const ContentImage = styled.div`
  max-width: 100%;

  img {
    display: block;
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
`;

const ThankYou = styled.div`
  position: relative;

  p {
    margin: 0;
    padding: 4rem 4.5rem;
    font-size: 20px;
    color: white;
    text-align: center;
  }

  /* && beats Button's own sizes, which come later in the file. */
  && button {
    width: 30px;
    height: 30px;

    svg {
      height: 12px;
      width: 12px;
    }
  }
`;

export const Button = styled.div`
  position: absolute;
  right: 12px;
  top: 12px;

  button {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 36px;
    height: 36px;
    border: none;
    border-radius: 50%;
    background-color: rgba(255, 255, 255, 0.9);
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.2);
    padding: 0;
    margin: 0;
    transition: background-color 0.15s;

    &:hover {
      background-color: white;
    }

    &:focus-visible {
      outline: 2px solid #deccbe;
      outline-offset: 2px;
    }

    span {
      display: flex;
    }

    svg {
      height: 14px;
      width: 14px;
    }
  }
`;

export const Field = styled.fieldset`
  border: 1px solid ${colors.lightBorder};
  border-radius: 6px;
  padding-bottom: 4px;
`;

export const StyledInput = styled.input`
  font-size: 14px;
  line-height: 1;
  background-color: white;
  padding: 0 20px;
  height: 48px;
  border-radius: 999px;
  text-align: center;
  outline: none;
  border: 2px solid transparent;
  width: 80%;
  transition: border-color 0.15s;

  &::placeholder {
    color: ${colors.fadedText};
  }

  &:focus-visible {
    border-color: #deccbe;
  }
`;

export const SubmitButton = styled.input`
  font-weight: bold;

  color: black;
  background-color: #deccbe;
  font-size: 15px;
  letter-spacing: 0.02em;
  height: 48px;
  border-radius: 999px;
  border: none;
  width: 80%;
  box-shadow: 0 4px 14px rgba(0, 0, 0, 0.25);
  transition: transform 0.15s, box-shadow 0.15s, background-color 0.15s;

  &:disabled {
    cursor: not-allowed;
    opacity: 0.7;
  }

  &:hover:not(:disabled) {
    background-color: #e8dacf;
    transform: translateY(-1px);
    box-shadow: 0 6px 18px rgba(0, 0, 0, 0.3);
  }

  &:focus-visible {
    outline: 2px solid white;
    outline-offset: 2px;
  }
`;

const EmailModal = ({ onCloseClick, onJoin, onThanks }) => {
  const dispatch = useDispatch();

  const isFetching = useSelector(getIsFetching);
  const [email, setEmail] = useState('');
  const [error, setError] = useState('');
  const [succes, setSucces] = useState(false);

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!email.trim()) {
      setError('Please fill out all fields');
      return;
    }

    try {
      dispatch(setIsFetching(true));
      setSucces(true);
      onThanks?.();
      useEmailTag({ email });

      setTimeout(() => {
        onJoin(email);
      }, 2000);
    } catch (e) {
      console.log(e);
    } finally {
      dispatch(setIsFetching(false));
    }
  };

  return (
    <ContentWrapper>
      <Media />
      {succes && (
        <ThankYou>
          <p>Thank you! You're on the list.</p>
          <Button>
            <button onClick={onCloseClick} aria-label="Close">
              <CloseIcon />
            </button>
          </Button>
        </ThankYou>
      )}
      {!succes && (
        <Wrapper>
          <ContentImage>
            <img src={EMAIL_MODAL_PHOTO} alt="" width="567" height="600" />
          </ContentImage>
          <Content2>
            <Subcontent>
              <div>
                <Title>Welcome to Yedding</Title>
                <SubTitle>We're constantly adding fresh, one-of-a-kind venues for corporate events, weddings, and all kinds of celebrations.</SubTitle>
                <SubTitle>Enter your email below for exclusive early access, before anyone else.</SubTitle>
              </div>
              <form onSubmit={handleSubmit} style={{ textAlign: 'center' }}>
                <Field>
                  <StyledInput type="email" value={email} onChange={(e) => setEmail(e.target.value)} placeholder="Email Address" />
                </Field>
                {!!error && <ErrorMessage>{error}</ErrorMessage>}
                <SubmitButton type="submit" disabled={isFetching} value={isFetching ? 'Loading...' : 'Get Early Access'} />
              </form>
            </Subcontent>
            <Button>
              <button onClick={onCloseClick} aria-label="Close">
                <CloseIcon />
              </button>
            </Button>
          </Content2>
        </Wrapper>
      )}
    </ContentWrapper>
  );
};

export default EmailModal;
